import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from 'src/app/shared/pless-shared.module';
import { NgModule } from '@angular/core';
import { KYMW1706Component } from './kymw1706.component';

/**
 * 過去画像登録画面 モジュール設定クラス
 *
 * @export KYMW1706Module
 * @class KYMW1706Module
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule
  ],
  declarations: [
    KYMW1706Component
  ],
})

export class KYMW1706Module { }
